import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private sessionServices: SessionService,
    private router: Router,
  ){ }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!this.sessionServices.AnyActiveSession()){
        this.router.navigate(['/login'])
      } else {
          if(new Date(this.sessionServices.GetCompleteToken().expires) < new Date()) {
            return false
          }
      }
    return true;
  }

}
